<template>
  <v-card
    max-width="400"
    class="mx-auto rounded-lg"
  >
    <v-list two-line>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-numeric</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Numéro</v-list-item-title>
          <v-list-item-subtitle>{{ this.job.numero }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-school</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            {{ job.type_emploi === 'ADM' ? 'Niveau' : 'Cours à conférer' }}
          </v-list-item-title>
          <v-list-item-subtitle>{{ this.job.nom }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-briefcase</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Fonction</v-list-item-title>
          <v-list-item-subtitle>{{ this.job.fonction }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-if="job.type_emploi === 'ADM'">
        <v-list-item-icon>
          <v-icon>mdi-office-building</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Service</v-list-item-title>
          <v-list-item-subtitle>{{ this.job.service }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-abacus</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Volume de la charge</v-list-item-title>
          <v-list-item-subtitle>
            {{ this.job.volume }} {{ this.job.type_emploi === 'ENS' ? '/10' : '/38' }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-map-marker</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Implantation</v-list-item-title>
          <v-list-item-subtitle>{{ this.job.implantations.join(', ') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item v-if="job.description">
        <v-list-item-icon>
          <v-icon>mdi-information</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Description</v-list-item-title>
          <v-list-item-subtitle>
            <job-desc-dial
              :description="job.description"
              v-model="descIsActive"
            ></job-desc-dial>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>

    <v-card-actions>
      <v-btn
        text
        to="/vacant-jobs"
      >
        Retour
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn
        text
        color="primary"
        @click="$emit('confirm-next')"
      >
        Continuer
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import JobDescDial from '@/components/apply/JobDescDial.vue';

export default {
  name: 'JobResume',

  components: {
    'job-desc-dial': JobDescDial,
  },

  props: {
    job: Object,
  },

  data: () => ({
    descIsActive: false,
  }),
};
</script>
